export default "__VITE_ASSET__B7bCqFg4__"